module.exports = __webpack_public_path__ + "img/add-user.e107f608.svg";